import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "next-i18next";

const WhatIsVirtualServer = () => {
    const { t } = useTranslation(["common", "windowsCloudServer"]);
    const [activeSection, setActiveSection] = useState("virtual-server");
    const contentRef = useRef(null);
    const itemRefs = useRef([]);

    const sections = [
        {
            id: "virtual-server",
            title: t("common:whatIsAVirtualServer"),
            desc: t("common:whatIsAVirtualServerDesc"),
        },
        {
            id: "used-for",
            title: t("common:whatIsAVirtualServerUsedFor"),
            desc: t("common:whatIsAVirtualServerUsedForDesc")
        },
        {
            id: "advantages",
            title: t("common:advantagesOverPhysicalServers"),
            desc: t("common:advantagesOverPhysicalServersDesc"),
        },
        {
            id: "security",
            title: t("common:highlightsOfWindowsVirtualServers"),
            desc: t("common:highlightsOfWindowsVirtualServersDesc"),
        },
        {
            id: "performance",
            title: t("common:virtualServerUsageAreas"),
            desc: t("common:virtualServerUsageAreasDesc"),
        },
        {
            id: "cost-effectiveness",
            title: t("common:securityOfVirtualServers"),
            desc: t("common:securityOfVirtualServersDesc"),
        },
        {
            id: "scalability",
            title: t("common:keyFeaturesOfVirtualServerSecurity"),
            desc: t("common:keyFeaturesOfVirtualServerSecurityDesc"),
        },
        {
            id: "usability",
            title: t("common:securityAdvantagesOfVirtualServers"),
            desc: t("common:securityAdvantagesOfVirtualServersDesc"),
        },
    ];

    const handleClick = (id) => {

        const contentBox = contentRef.current; // Container referansı
        const element = document.getElementById(id); // Hedef eleman

        if (element && contentBox) {
            // Elemanın container'a göre top pozisyonunu hesapla
            const elementTop = element.getBoundingClientRect().top - contentBox.getBoundingClientRect().top;

            // Container'ın mevcut scrollTop değerine elemanın pozisyonunu ekle
            const scrollTopValue = contentBox.scrollTop + elementTop - 7;

            // Container içinde scroll yap
            contentBox.scrollTo({
                top: scrollTopValue, // Tam hizalama için hesaplanan değer
                behavior: "smooth",
            });
        }
    };

    const handleScroll = () => {
        if (!contentRef.current) return;

        const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
        // Scroll pozisyonunu kontrol et
        const contentTop = contentRef.current.getBoundingClientRect().top;

        // Her bir öğenin pozisyonunu kontrol et
        if (scrollTop + clientHeight >= scrollHeight - 1) {
            setActiveSection(sections[sections.length - 1].id);
            return;
        }
        else {
            for (let i = itemRefs.current.length - 1; i >= 0; i--) {
                const ref = itemRefs.current[i];
                if (ref) {
                    const rect = ref.getBoundingClientRect();

                    // Eğer öğenin üst kısmı container'ın üst kısmından daha yukarıdaysa, o öğeyi aktif yap
                    if (rect.top < contentTop + 200) {
                        setActiveSection(sections[i].id);
                        return;
                    }
                }
            }
        }
        // Eğer hiçbir şey eşleşmezse, ilk öğeyi aktif yap
        setActiveSection(sections[0].id);
    };

    useEffect(() => {
        const container = contentRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            handleScroll(); // İlk yüklemede çalıştır
            return () => container.removeEventListener("scroll", handleScroll);
        }
    }, [sections]);

    return (
        <div className="container px-4 py-10 mx-auto lg:py-20 lg:px-0">
            <div className="grid grid-cols-2 gap-10">
                {/* Sol Menü */}
                <div className="hidden col-span-2 lg:col-span-1 lg:block">
                    <div className="flex flex-col items-center justify-center mb-4">
                        <Image
                            src={"/whatIsVirtualServer.svg"}
                            width={557}
                            height={216}
                            alt={t("windowsCloudServer:whatIsAVirtualServer")}
                            title={t("windowsCloudServer:whatIsAVirtualServer")}
                        />
                    </div>
                    <ul className="space-y-5">
                        {sections.map((section, index) => (
                            <li
                                key={index}
                                onClick={() => section.id != activeSection && handleClick(section.id)}
                                className={`cursor-pointer text-lg font-semibold ${activeSection === section.id
                                    ? "text-black "
                                    : "text-textGray"
                                    }`}
                            >
                                • {section.title}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Sağ İçerik */}
                <div className="lg:mt-24  h-[488px] overflow-y-auto customScroll space-y-16 col-span-2 lg:col-span-1" ref={contentRef}>
                    {sections.map((section, index) => (
                        <div key={section.id} id={section.id} ref={(el) => (itemRefs.current[index] = el)} className={`${activeSection == section.id ? "" : "opacity-25"}  ${sections.length == index + 1 ? "pb-32" : ""}`}>
                            <h3 className={`text-textGray text-3xl px-1 font-semibold  ${activeSection === section.id ? 'w-fit bg-gradient-to-b  from-white  via-white  to-[#ffee80]  !leading-[40px]' : ''}`}>{section.title}</h3>
                            <div className="mt-4 text-textGray" dangerouslySetInnerHTML={{ __html: section.desc }}></div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WhatIsVirtualServer;